"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UiProvider = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const contentSize = tslib_1.__importStar(require("./content-size"));
const nanoTheme = tslib_1.__importStar(require("nano-theme"));
const traces = tslib_1.__importStar(require("./traces"));
const router_1 = require("../misc/router");
const context_1 = require("../7-fullscreen/ToastCardManager/context");
const services_1 = require("./services");
const NiceUiServices_1 = require("./services/NiceUiServices");
const kbd_1 = require("./kbd");
const useBehaviorSubject_1 = require("../hooks/useBehaviorSubject");
const ToastCardManager_1 = require("../7-fullscreen/ToastCardManager");
const context_2 = require("../styles/context");
const portal_1 = require("../utils/portal");
const ScopedResetContext_1 = require("./ScopedResetContext");
const UiProvider = ({ globalCss, theme, nav, content, children }) => {
    const services = React.useMemo(() => new NiceUiServices_1.NiceUiServices({
        nav,
        content,
    }), [nav, content]);
    const pathname = (0, useBehaviorSubject_1.useBehaviorSubject)(services.nav.pathname$);
    const theme2 = (0, useBehaviorSubject_1.useBehaviorSubject)(services.theme$);
    const scopedResetClass = React.useMemo(() => (globalCss ? null : nanoTheme.getScopedResetClass()), [globalCss]);
    return (React.createElement(traces.ctx.Provider, { value: {} },
        React.createElement(services_1.context.Provider, { value: services },
            React.createElement(ScopedResetContext_1.ScopedResetContext.Provider, { value: scopedResetClass },
                React.createElement(nanoTheme.Provider, { theme: theme ?? (theme2 === 'dark' ? 'dark' : 'light') },
                    React.createElement(context_2.Provider, { dark: (theme ?? theme2) === 'dark' },
                        React.createElement(kbd_1.Kbd, null,
                            React.createElement(context_1.ToastsProvider, null,
                                React.createElement(portal_1.PortalProvider, null,
                                    globalCss && React.createElement(nanoTheme.GlobalCss, null),
                                    React.createElement(contentSize.context.Provider, { value: contentSize.DEFAULT },
                                        React.createElement(router_1.Router, { route: pathname }, children)),
                                    React.createElement(ToastCardManager_1.ToastCardManager, null))))))))));
};
exports.UiProvider = UiProvider;
